import { makeStyles } from '@material-ui/core/styles';

export const useHeaderLinksStyles = makeStyles({
  root: {
    background: '#222222',
    fontSize: '12px',
    height: '28px',
    fontFamily: 'Montserrat, Helvetica, Arial, sans-serif;',
    position: 'relative',
    top: 0,
    zIndex: 9999,
    maxWidth: (props) => (props.mobile ? '480px' : `display: 'none'`),
    '& nav': {
      margin: '0 auto',
      '& ul': {
        margin: '0 auto',
        display: 'flex',
        lineHeight: 1.5,
        listStyle: 'none',
        padding: 0,
        '& li': {
          padding: '5px 8px 5px',
          margin: 0,
          '&:hover': {
            background: '#404040',
          },
        },
        '& a': {
          textDecoration: 'none',
          color: '#97999b',
          cursor: 'pointer',
        },
      },
    },
  },
});

export const useHeaderMainStyles = makeStyles({
  divider: {
    height: 70,
    '&.MuiDivider-root': {
      background: '#464646',
    },
  },
  typo: {
    fontSize: 26,
    fontWeight: 600,
  },
});

export const useHeaderStyles = makeStyles((theme) => ({
  mainRoot: {
    '&.MuiAppBar-colorPrimary': {
      backgroundColor: 'rgb(26, 26, 26)',
    },
    zIndex: theme.zIndex.drawer + 1,
  },
}));
